import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteAdminExpertLevel() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "expert-levels", "delete"],
    mutationFn: async (expertLevelId: number) => {
      return await api.admin.expertLevels.deleteLevel({
        params: { expertLevel: expertLevelId },
      });
    },
    onSuccess: () => {
      toaster.create({ title: "Expert level deleted successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-levels"] });
    },
    onError: (error: Error) => {
      toaster.create({ title: `Failed to delete expert level: ${error.message}`, type: "error" });
    },
  });
}
